const IMetricsClient = require("./IMetricsClient.js");
const SentryBrowserClient = require("./SentryBrowserClient.js");
const SentryNodeClient = require("./SentryNodeClient.js");
const DEFAULT_ALLOWED_ATTRIBUTES = require("./defaultAllowedAttributes.js");

module.exports = {
  IMetricsClient,
  SentryBrowserClient,
  SentryNodeClient,
  DEFAULT_ALLOWED_ATTRIBUTES
};
